<template>
  <div class="container">
    <HeaderComponent :callBack="callBackChange"/>
    <div class="inner-container">
      <div class="inner-container-left">
        <div v-for="(item, index) in listData" :key="index" class="children" @click="_handleToDetail(item.ID)">
          <span class="title">{{ item.post_title }}</span>
          <div class="views">
            <span>发布于：{{ item.date }}</span>
            <span style="margin-left: 10px;">浏览次数：{{ item.views_count }}</span>
          </div>
          <span class="intro-space">{{ item.post_content }}</span>
          <span class="intro-space" style="color: #999999">查看详情>></span>
        </div>
      </div>
      <div class="inner-container-right">
        <RightNewsComponent/>
        <div style="height: 20px;"/>
        <RightHuoDongComponent/>
      </div>
    </div>
    <PageFen :currentPage="pageNow" :showItemPerPage="8" :totalPage="pageTotal" :callBack="pageChange"/>
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from "@/components/HeaderComponent";
import FooterComponent from "@/components/FooterComponent";
import RightNewsComponent from "@/components/RightNewsComponent";
import RightHuoDongComponent from "@/components/RightHuoDongComponent";
import PageFen from "@/components/PageFen";
import http from "@/util/http";
// import { ElLoading } from "element-plus"

export default {
  name: "OutViewFace",
  components: {
    PageFen,
    RightHuoDongComponent,
    RightNewsComponent,
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      child: undefined,
      id: undefined,
      pageNow: 1,
      pageTotal: 1,
      listData: []
    }
  },
  created() {
    this._getQuery()
    this._getList()
  },
  methods: {
    _getQuery() {
      const query = this.$route.query
      if (query.page) {
        this.pageNow = query.page
      }
      this.child = query.child
      this.id = query.id
    },
    callBackChange(e){
      console.log(e)
      this._getQuery()
      this._getList()
    },
    pageChange(e) {
      this.pageNow = e
      this._getList()
      window.scrollTo(0,0)
    },
    _handleToDetail(e) {
      this.$router.push({
        path: '/DetailPage',
        query: {
          p: e
        }
      })
    },
    _getList() {
      http.get('otherPage', {
        page: this.pageNow,
        child: this.child,
        id: this.id
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.listData = res.data.data.list
              this.pageTotal = res.data.data.pageTotal
            }
          })
    }
  }
}
</script>

<style scoped>
.inner-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}

.inner-container-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.inner-container-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.children {
  border-bottom: 1px solid #dddddd;
  padding: 30px 0 40px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  cursor: pointer;
}

.title {
  font-size: 20px;
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  color: #333333;
}

.views {
  font-size: 14px;
  color: #676767;
  margin-top: 10px;
  font-weight: bold;
}

.intro-space {
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
  font-weight: bold;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 28px;
  -webkit-box-orient: vertical;
  text-align: start;
}
</style>